<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<div class="check-cat widget" v-for="cat in checklistCategories" :key="cat">
					<div class="title mb-4">{{cat}}</div>
					<div class="row no-pad mb-2">
						<div class="col-1 vh-align-center"><strong>Yes</strong></div>
						<div class="col-1 vh-align-center"><strong>No</strong></div>
						<div class="col-10"></div>
					</div>
					<div class="row no-pad mb-2" v-for="check in checklistByCat(cat)" :key="check.id">
						<div class="col-1 vh-align-center">
							<input type="radio" :name="'group'+check.id" value="yes" @click="setAnswer(check.id, 'yes')">
						</div>
						<div class="col-1 vh-align-center">
							<input type="radio" :name="'group'+check.id" value="no" @click="setAnswer(check.id, 'no')">
						</div>
						<div class="col-10">{{check.value}}</div>
						<div class="col-12 check-answer" :class="{'show':check.answer != ''}">
							<div class="yes" v-if="check.answer == 'yes'">{{check.yes_value}}</div>
							<div class="no" v-if="check.answer == 'no'">{{check.no_value}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
//importing widgets
import textcontent from '../components/widgets/text'
import videowidget from '../components/widgets/video'
import gallerywidget from '../components/widgets/gallery'
import subsectionwidget from '../components/widgets/subsection'
import accordionwidget from '../components/widgets/accordion'
import userlist from '../components/track/userlist'

Vue.use(CxltToastr)

export default {
	components: {
		textcontent,
		videowidget,
		gallerywidget,
		accordionwidget,
		subsectionwidget,
		userlist
	},
	props:['type'],
	name: 'checklist',
	watch:{ // watching for route change
		$route (to, from){
				this.$nextTick(() => {
					this.getPagedata()
				})
		}
	},
	computed: { // setting list of widgets
		widgets() {
			return this.components
		}
	},
	data() {
		return {
			ps:null,
			page:'',
			pageData:[],
			components:[],
            comp:[],
			checklist:[],
			checklistCategories:[],
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true
		}
	},
	mounted: function() {
		!localStorage.lang ? localStorage.lang = 'en' : ''
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.page = this.urlCheck('last')
			let url = this.type == 'subsection' || this.urlCheck('first') ? 'subsection/' : 'section/'
			this.axios.get(process.env.VUE_APP_URL+url+this.page, {params:{name:this.page, language:this.lang}})
			.then(response => {
				this.pageData = response.data
                this.prepareComponents()
                this.getChecklist()
			})
			.catch(error => {
			 	this.$router.push({path:'/404'})
			})
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.accordions && this.pageData.accordions.length > 0) {
				this.pageData.accordions.map(a => {
					a.type = 'accordionwidget'
					this.components.push(a)
				})
			}
			if(this.pageData.galleries && this.pageData.galleries.length > 0) {
				this.pageData.galleries.map(a => {
					a.type = 'gallerywidget'
					this.components.push(a)
				})
			}
			if(this.pageData.subsections && this.pageData.subsections.length > 0) {
				this.pageData.subsections.map(a => {
					a.type = 'subsectionwidget'
					this.components.push(a)
				})
			}
			if(this.pageData.videos && this.pageData.videos.length > 0) {
				this.pageData.videos.map(a => {
					a.type = 'videowidget'
					this.components.push(a)
				})
			}
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
					this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)
        },
        getChecklist: function() {
            this.axios.get(process.env.VUE_APP_URL+'checklist', {params:{language:this.lang}})
			.then(response => {
				response.data.map(c => {
					let exist = false
					c.answer = ''
					this.checklistCategories.map(cat => {
						cat == c.category ? exist = true : ''
					})
					!exist ? this.checklistCategories.push(c.category) : ''
				})
				this.checklist = response.data
                this.loading = false
                this.$nextTick(() => {
                    this.perfectScrollInit()
                })
			})
		},
		checklistByCat: function(cat) { // filtering checklist by category name
				let list = []
				this.checklist.map(c => {
					c.category == cat ? list.push(c) : ''
				})
				return list
		},
		setAnswer(id,value) {
			this.checklist.map(cl => {
				cl.id == id ? cl.answer = value : ''
			})
		},
		urlCheck: function(type) { // checking path for 3 level menu and getting menu name
			let url = this.$route.path.split('/')
			return type == 'last' ? url[url.length-1] : url.length > 3 ? true : false
		},
		validateForm: function() { // only for about parachute page we validating and sending email form
			if(this.contactEmail.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your email address',
					position: 'top right',
					timeOut: 5000
				})
			} else if(this.contactName.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your name',
					position: 'top right',
					timeOut: 5000
				})
			} else if(this.contactMessage.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your enquiry',
					position: 'top right',
					timeOut: 5000
				})
			} else {
				this.axios.post(process.env.VUE_APP_URL+'contact', {
					reply_to: this.contactEmail,
					name: this.contactName,
					message: this.contactMessage
				})
				.then(response => {
					this.contactEmail = ''
					this.contactName = ''
					this.contactMessage = ''
					this.$toast.success({
						title:'Success',
						message: 'Your message was sent successfully',
						position: 'top right',
						timeOut: 5000
					})
				})
			}
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>